import React from 'react'
import PropTypes from 'prop-types'

import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
    button: {
        background: 'transparent',
        borderRadius: theme.borderRadius,
        borderStyle: 'none',
        borderWidth: 'none',
        cursor: 'pointer',
        display: 'inline-block',
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: '0.2px',
        lineHeight: '16px',
        padding: '12px 68px',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `background-color ${theme.animations.animate}, color ${theme.animations.animate}`,

        '&:hover': {
            backgroundColor: theme.colors.sunflower,
        },
    },
    yellow: {
        backgroundColor: theme.colors.yellow,
        color: theme.colors.blue,
    },
    'white-blue': {
        backgroundColor: theme.colors.white,
        color: theme.colors.marine,
        '&:hover': {
            backgroundColor: theme.colors.blue,
            color: theme.colors.white,
        },
    },
    'blue-white': {
        backgroundColor: theme.colors.blue,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.colors.white,
            color: theme.colors.marine,
        },
    },
    'grey-white': {
        backgroundColor: theme.colors.lightgrey,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.colors.yellow,
            color: theme.colors.marine,
        },
    },
    disabled: {
        backgroundColor: theme.colors.stormcloud,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.colors.stormcloud,
            color: theme.colors.marine,
        },
    },
    booking: {
        margin: '0 10px 0 20px',
        minHeight: '110px',
        width: '150px',
        padding: '12px 20px',
    },
    fluid: {
        paddingBottom: '12px',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingTop: '12px',
        width: '100%',
    },
    small: {
        padding: '12px 25px',
    },
    upgradeCar: {
        '@media (max-width: 1439px)': {
            minWidth: 146,
            boxSizing: 'border-box',
            padding: '12px 18px',
        },
        '@media (max-width: 899px)': {
            minWidth: 118,
            padding: '12px 9px',
        },
    },
}))

export const Button = ({
    children,
    color,
    href,
    title,
    type,
    onClick,
    fluid,
    disabled,
    booking,
    size,
    modifier,
    ...rest
}) => {
    const classes = useStyles()
    let styles = classes.button
    styles = `${styles} ${classes[color]}`
    if (fluid) {
        styles = `${styles} ${classes.fluid}`
    }
    if (booking) {
        styles = `${styles} ${classes.booking}`
    }
    if (size) {
        styles = `${styles} ${classes[size]}`
    }
    if (modifier) {
        styles = `${styles} ${classes[modifier]}`
    }
    if (disabled) {
        styles = `${styles} ${classes.disabled}`
    }

    /*
  When you pass in fluid/booking booleans, they check to see if
  they should add the corresponding classes, but later in the peice we added size which directly
  references the key in the classes object. You will notice modifier does the exact same thing, we
  needed to add another dimension later down the project track. Ideally from here, you would refactor size/modifier
  props to accept an array of strings, that can be then used to reference keys in the styles - to avoid the duplication in
  logic and add more flexilibity (you could probably also refactor fluid/booking into this array too) */

    return (
        <>
            {type === 'link' || href != undefined ? (
                <a className={styles} href={href} title={title}>
                    {children}
                </a>
            ) : (
                <button
                    className={styles}
                    onClick={onClick}
                    title={title}
                    disabled={disabled != undefined ? disabled : false}
                    {...rest}
                >
                    {children}
                </button>
            )}
        </>
    )
}

Button.defaultProps = {
    color: 'yellow',
    type: 'button',
    href: undefined,
    fluid: true,
}

Button.propTypes = {
    color: PropTypes.string,
    type: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
    fluid: PropTypes.bool,
    booking: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(undefined)]),
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
    modifier: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
}

export default Button
